/**
 * The For grown-ups gate (kid engagement PRD F2): press and hold, long
 * enough that a young child's tap does not open it. Not security.
 */
export const HOLD_MS = 2000;

export function holdProgress(pressedAt: number | null, now: number, ms = HOLD_MS): number {
  if (pressedAt === null) return 0;
  return Math.min(1, Math.max(0, (now - pressedAt) / ms));
}

export function holdDone(pressedAt: number | null, now: number, ms = HOLD_MS): boolean {
  return holdProgress(pressedAt, now, ms) >= 1;
}
